<template>
  <div class=''>
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <div><img src="@/assets/images/tjtcLTD.png" alt="" /></div>
                  <p><br /></p>
                  <p class="text">
                    天津市旅游（控股）集团有限公司2000年由市旅游局整建制转制为集团公司，2002年5月正式挂牌运营，是以都市旅游、文旅服务为核心的市级投资管理平台型集团。拥有旅游、酒店、配套服务等多业务板块，汇聚水上观光体验、旅游线路服务、酒店住宿、商贸娱乐美食综合体、车辆差旅外包服务、物业管理、人才服务等多元业态。旗下有企业35家，新三板上市企业1家，资产规模近75亿元，打造了“天津旅游名片”海河游船、“博物馆酒店”利顺德大饭店、“最美生活方式酒店”燕园国际大酒店等多个国内知名文旅品牌。
                  </p>
                  <p><br /></p>
                  <p class="text">
                    多年来，天津旅游集团立足全市文旅产业发展大局，积极发挥文旅产业“龙头骨干链主”作用，推动实施“1+2”发展战略，有效整合全市文旅资源，举办系列特色文旅活动，推出精品文旅服务项目，实现“串珠成链”“连线成片”。作为国内一流专业化集团公司，加大战略合作引入实力资本和优质IP，实施文旅产业项目开发，点亮天津旅游名片，带动天津市文旅产业发展，为建设国际消费中心城市做出国企贡献。
                  </p>
                  <p><br /></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  beforeDestroy() { },
  methods: {}
}
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;

  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;

    .inner_content_right {

      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }

      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;
        ;

        .head {
          border-bottom: 1px #444 dashed;
          height: 500px;
        }
      }

      .text {
        text-indent: 45px;
      }

      .ltd {
        float: right;
      }
    }
  }
}
</style>